import { FunctionComponent } from 'react'

import dynamic from 'next/dynamic'
import styled, { css } from 'styled-components'

import { CookWidget, JSONTypeForCookWidget } from '@widgets/types'

interface SourceProps {
  text: string
}

const HTMLView = dynamic(() => import('@components/HTMLView'))

const allowedHtmlTags = ['p', 'em', 'strong', 'a', 'sub', 'sup']

const StyledSource = styled.div`
  ${({
    theme: {
      typography: {
        bodycopy: {
          xsmall: { bundledCSS: bodycopyXSmallCSS },
        },
      },
      colors: { textDefault },
    },
  }) => css`
    p {
      ${bodycopyXSmallCSS};
      margin: 0;
      color: ${textDefault};
    }
  `}
`

const Source: FunctionComponent<SourceProps> = ({ text }) => {
  if (!text) {
    return null
  }

  return (
    <StyledSource>
      <HTMLView content={text} allowedHtmlTags={allowedHtmlTags} />
    </StyledSource>
  )
}

const widget = {
  kind: ['widget', 'source'],
  component: Source,
} as const satisfies CookWidget

export type WidgetType = typeof widget

export type JSONWidgetType = JSONTypeForCookWidget<WidgetType>

export default widget
